var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.999C14.165 13.999 15.165 14.673 15.662 15.645C17.106 14.198 18 12.201 18 9.99902C18 5.58802 14.411 1.99902 10 1.99902C5.589 1.99902 2 5.58802 2 9.99902C2 12.201 2.894 14.198 4.338 15.645C4.835 14.673 5.836 13.999 7 13.999H13ZM7 15.999C6.475 15.999 6.055 16.411 6.015 16.926C7.19 17.605 8.548 17.999 10 17.999C11.452 17.999 12.81 17.605 13.985 16.926C13.946 16.411 13.526 15.999 13 15.999H7ZM0 9.99902C0 4.48602 4.486 -0.000976562 10 -0.000976562C15.514 -0.000976562 20 4.48602 20 9.99902C20 15.513 15.514 19.999 10 19.999C4.486 19.999 0 15.513 0 9.99902ZM8.0001 7.99952C8.0001 9.10252 8.8971 9.99952 10.0001 9.99952C11.1031 9.99952 12.0001 9.10252 12.0001 7.99952C12.0001 6.89652 11.1031 5.99952 10.0001 5.99952C8.8971 5.99952 8.0001 6.89652 8.0001 7.99952ZM6.0001 7.99952C6.0001 5.79352 7.7941 3.99952 10.0001 3.99952C12.2061 3.99952 14.0001 5.79352 14.0001 7.99952C14.0001 10.2055 12.2061 11.9995 10.0001 11.9995C7.7941 11.9995 6.0001 10.2055 6.0001 7.99952Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonRound);
export default __webpack_public_path__ + "static/media/PersonRound.c8f40442.svg";
export { ForwardRef as ReactComponent };